/*
 * GSTR9New Common Reducer
 *
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 * Example:
 * case YOUR_ACTION_CONSTANT:
 *   return state.set('yourStateVariable', true);
 */

import produce from 'immer';
import {
  LOADER_STATUS,
  PROFILE_INFO,
  ON_NOTIFY,
  RESPONSE_MESSAGE,
  SET_TABLE_DATA,
  TOTAL_RECORD,
  FILE_UPLOAD_STATUS,
  FILE_VALIDATION_ERROR,
  SET_ENTITY_LIST,
  SET_SELECTED_ENTITY,
  SET_SELECTED_GSTIN,
  SET_SELECTED_RETURN_PERIOD,
  API_SUCCESS,
  API_ERROR,
} from './constants';

// The initial state of the GSTR9New Common
export const initialState = {
  loaderStatus: false,
  profileData: [],
  entityList: [],
  notificationStatus: false,
  notificationMessage: '',
  responseStatus: false,
  responseMessage: '',
  responseError: null,
  tableData: [],
  totalRecords: 0,
  records: [],
  uploadStatus: '',
  validationError: '',
  apiSuccess: false,
  apiError: false,
  selectedEntity: '',
  selectedGstin: [],
  selectedReturnPeriod: '',
};

/* eslint-disable default-case, no-param-reassign */
const gstr9NewCommonReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case LOADER_STATUS:
        draft.loaderStatus = action.loaderStatus;
        break;

      case PROFILE_INFO:
        draft.profileData = action.profileData;
        break;

      case SET_ENTITY_LIST:
        draft.entityList = action.payload;
        break;

      case SET_SELECTED_ENTITY:
        draft.selectedEntity = action.payload;
        // Clear GSTIN list when entity changes
        draft.selectedGstin = [];
        draft.profileData = [];
        break;

      case SET_SELECTED_GSTIN:
        draft.selectedGstin = action.payload;
        break;

      case SET_SELECTED_RETURN_PERIOD:
        draft.selectedReturnPeriod = action.payload;
        break;

      case ON_NOTIFY:
        draft.notificationStatus = action.status;
        draft.notificationMessage = action.msg;
        break;

      case RESPONSE_MESSAGE:
        draft.responseStatus = action.status;
        draft.responseMessage = action.msg;
        draft.responseError = action.error;
        break;

      case SET_TABLE_DATA:
        draft.tableData = action.tableData;
        break;

      case TOTAL_RECORD:
        draft.totalRecords = action.totalRecords;
        draft.records = action.records;
        break;

      case FILE_UPLOAD_STATUS:
        draft.uploadStatus = action.uploadStatus;
        break;

      case FILE_VALIDATION_ERROR:
        draft.validationError = action.validationError;
        break;

      case API_SUCCESS:
        draft.apiSuccess = true;
        draft.apiError = false;
        break;

      case API_ERROR:
        draft.apiSuccess = false;
        draft.apiError = true;
        break;
    }
  });

export default gstr9NewCommonReducer;
